import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      dark: {
        primary: '#23cf65',
        background: '#000000',
        surface: '#111111',
      },
      light: {
        primary: '#23cf65',
        background: '#f5f5f5',
        surface: '#ffffff',
      },
    },
  },
  typography: {
    fontFamily: 'Poppins, Arial, sans-serif',
  },
});
